<!--
/**
 * DjCapitalPoolTab.vue - 资金池 Tab 组件
 *
 * 【功能说明】
 * 本组件是迪加(DJ)虚拟商品管理系统的资金池管理页面，
 * 用于查看和管理资金池的余额信息。可以查看资金池的剩余量，
 * 查看资金池的充值历史记录，以及手动添加资金到资金池。
 *
 * 【主要功能】
 * 1. 资金池余额展示 - 以卡片形式展示当前资金池的剩余量
 * 2. 资金池记录 - 展示资金池的充值金额和时间历史记录
 * 3. 添加金额 - 手动向资金池添加指定金额
 *
 * 【权限要求】
 * - 所有用户：可执行所有操作
 -->
<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="20">
        <el-row :gutter="20" class="mgb20">
          <!-- ========== 资金池余额卡片 ========== -->
          <el-col :span="8">
            <el-card shadow="hover" :body-style="{ padding: '0px' }">
              <div class="grid-content grid-con-2">
                <i class="el-icon-receiving grid-con-icon"></i>
                <div class="grid-cont-right">
                  <!-- 剩余量数字（使用主题色） -->
                  <div class="grid-num" :class="theme3">{{ capitaltotal || 0 }}</div>
                  <div>剩余量</div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="4">
        <!-- 添加金额按钮 -->
        <el-button size="small" type="primary" :class="[theme]"
                   @click="addCapital">添加金额
        </el-button>
      </el-col>
    </el-row>

    <!-- ========== 资金池记录表格 ========== -->
    <!-- 展示资金池的充值金额和时间记录 -->
    <div class="container">
      <el-table v-loading="loading" :data="capitaltableData" border class="table m_t_20"
                header-cell-class-name="table-header" :row-style="{ height: '20px' }"
                :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ padding: '6px' }" stripe>
        <!-- 充值金额（带单位"元"） -->
        <el-table-column prop="label" label="数量" align="center">
          <template #default="scope">
            <span>{{ scope.row.label }}元</span>
          </template>
        </el-table-column>
        <!-- 充值时间 -->
        <el-table-column prop="value" label="时间" align="center"></el-table-column>
      </el-table>
    </div>

    <!-- ========== 添加金额弹窗 ========== -->
    <!-- 手动向资金池添加指定金额 -->
    <el-dialog title="添加金额" v-model="addCapitalNum" width="450px" @close="closeCapitalNum"
               :close-on-click-modal="false">
      <el-form :model="capitalForm" ref="form" label-width="100px">
        <el-form-item label="添加金额">
          <el-input size="small" style="width: 250px;" placeholder="请输入添加金额"
                    v-model="capitalForm.amount"></el-input>
          <span class="m_l_10">元</span>
        </el-form-item>
        <div class="dis-end">
          <el-button size="small" class="btn" @click="closeCapitalNum">取消</el-button>
          <el-button size="small" class="btn" :class="[theme]" style="border: none;" type="success"
                     @click="getcapitalPoolAdd">确定
          </el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 资金池 Tab 组件脚本部分
 *
 * 引入的 API 接口：
 * - fundPoolAdd：向资金池添加金额
 * - fundPool：查询资金池信息（余额和记录）
 */
import {
  fundPoolAdd,
  fundPool
} from '../../../api/dijia.js';

export default {
  name: 'DjCapitalPoolTab',

  /**
   * 【Props 接收的参数】
   * - theme：主题颜色样式类名
   * - theme3：辅助主题颜色类名（用于余额数字颜色）
   */
  props: {
    theme: { type: String, default: '' },
    theme3: { type: String, default: '' },
  },

  data() {
    return {
      // ========== 数据相关 ==========
      loading: false,           // 表格加载状态
      capitaltableData: [],     // 资金池记录列表
      capitaltotal: '',         // 资金池剩余总额

      // ========== 添加金额弹窗相关 ==========
      addCapitalNum: false,     // 弹窗是否显示
      capitalForm: {            // 添加金额表单
        amount: '',             // 添加金额
      },
    };
  },

  /**
   * 组件创建时查询资金池信息
   */
  created() {
    this.getfundPool();
  },

  methods: {
    /**
     * addCapital - 打开添加金额弹窗
     */
    addCapital() {
      this.addCapitalNum = true;
    },

    /**
     * closeCapitalNum - 关闭添加金额弹窗并清空表单
     */
    closeCapitalNum() {
      this.addCapitalNum = false;
      this.capitalForm.amount = '';
    },

    /**
     * getcapitalPoolAdd - 提交添加金额到资金池
     * 成功后关闭弹窗并刷新资金池数据
     */
    getcapitalPoolAdd() {
      let data = {
        amount: this.capitalForm.amount,
        userId: localStorage.getItem('user')
      };
      fundPoolAdd(data).then(res => {
        if (res?.code === 200) {
          this.$message.success(res.data);
          this.addCapitalNum = false;
          this.getfundPool();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * getfundPool - 查询资金池信息
     * 获取资金池的记录列表和剩余总额
     */
    getfundPool() {
      let data = { userId: localStorage.getItem('user') };
      fundPool(data).then(res => {
        if (res?.code === 200) {
          this.capitaltableData = res.data.selectorList;
          this.capitaltotal = Number(res.data.total.toFixed(2));
        } else {
          this.$message.error(res.message);
        }
      });
    },
  }
};
</script>

<style scoped>
@import './tab-styles.css';
</style>
